export const data = [
	{
		to: '/',
		text: 'About',
		id: 'about',
	},
	{
		to: '/applications',
		text: 'Application',
	},
	/*
	{
		to: '/pricing',
		text: 'Documentation',
	},*/
	{
		to: '/company',
		text: 'Company',
	},
	{
		to: '/contact',
		text: 'Contact',
	},
	
];
